import {
  locationIdFormat,
  productIdFormat,
  storageLocationIdFormat,
  taskIdFormat,
} from "@redotech/redo-ids-cockroach";
import { TaskStatusSchema } from "@redotech/redo-model/task/task";
import * as z from "zod";

export const getCycleCount = {
  name: "getCycleCount" as const,
  input: z.object({ taskId: taskIdFormat.schema }),
  output: z.object({
    id: taskIdFormat.schema,
    name: z.string().nullable(),
    status: TaskStatusSchema,
    locationId: locationIdFormat.schema.nullable(),
    locationName: z.string().nullable(),
    productIds: z.array(productIdFormat.schema),
    storageLocationIds: z.array(storageLocationIdFormat.schema),
    assignedLegacyUserId: z.string().nullable(),
    assignedRole: z.string().nullable(),
    completedBins: z.number(),
    totalBins: z.number(),
    dueAt: z.date().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
  }),
};
